import {ChangeDetectorRef, Directive, inject, OnDestroy} from '@angular/core';
import {NbDialogService} from '@nebular/theme';
import {FieldType} from '@ngx-formly/core';
import {TuiAlertService} from '@taiga-ui/core';
import {CompoApiService, Environment, ErrorDialogComponent} from 'compob2b-libs';
import {EMPTY, Subject} from 'rxjs';

@Directive()
export abstract class BaseFieldType extends FieldType implements OnDestroy {
  loading = false;

  protected readonly cdr = inject(ChangeDetectorRef);
  protected readonly dialogService = inject(NbDialogService);
  protected readonly compoApiService = inject(CompoApiService);
  private readonly alerts = inject(TuiAlertService);
  protected readonly environment = inject(Environment);
  protected readonly unsubscribe: Subject<boolean> = new Subject<boolean>();

  successToast(message: string) {
    this.alerts.open(message, {appearance: 'positive', autoClose: this.environment.toastrNotificationDuration}).subscribe();
  }

  warningToast(message: string) {
    this.alerts.open(message, {appearance: 'warning', autoClose: this.environment.toastrNotificationDuration}).subscribe();
  }

  errorToast(message: string) {
    this.alerts.open(message, {appearance: 'negative', autoClose: this.environment.toastrNotificationDuration}).subscribe();
  }

  protected handleError(err) {
    this.loading = false;

    console.error(err);
    this.cdr.detectChanges();
    this.dialogService.open(ErrorDialogComponent, {
      context: {
        err: err
      }
    });

    return EMPTY;
  }

  ngOnDestroy() {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
  }

  clear() {
    this.formControl.setValue(null);
    this.formControl.parent.updateValueAndValidity();
    this.cdr.detectChanges();
  }

  get selectOptions(): any[] {
    if (Array.isArray(this.props?.options)) {
      return this.compoApiService.naturalSort(this.props.options, 'label');
    }
    throw new Error('Async options not supported');
  }

  get hasValue() {
    return this.formControl.value && !(Array.isArray(this.formControl.value) && !this.formControl.value.length);
  }
}
